import { FAILED, SUCCESS } from "../utils/constants/tags";
import { getAbsoluteUrl } from "./urls";
import { fetchAuthenticated } from "./utils";

/**
 * Triggers a backup download for the given tax payer.
 * Returns the Blob so the caller can trigger a browser download.
 */
export const backupTaxPayer = async (
  taxPayerId: number,
): Promise<{ status: string; blob?: Blob; detail?: string }> => {
  const url = getAbsoluteUrl(`/backup/${taxPayerId}/`);

  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      method: "POST",
      headers: {},
      credentials: "include",
    });
  } catch {
    return { status: FAILED, detail: "Server not Found" };
  }

  if (!response.ok) {
    let detail = "Error desconocido";
    try {
      const body = await response.json();
      detail = body.error ?? detail;
    } catch {}
    return { status: FAILED, detail };
  }

  const blob = await response.blob();
  return { status: SUCCESS, blob };
};

/**
 * Restores a tax payer from a ZIP backup file.
 */
export const restoreTaxPayer = async (
  file: File,
): Promise<{ status: string; detail?: string; data?: any }> => {
  const url = getAbsoluteUrl("/backup/restore/");

  const arrayBuffer = await file.arrayBuffer();

  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/zip",
      },
      credentials: "include",
      body: arrayBuffer,
    });
  } catch {
    return { status: FAILED, detail: "Server not Found" };
  }

  if (!response.ok) {
    let detail = "Error desconocido";
    try {
      const body = await response.json();
      detail = body.error ?? detail;
    } catch {}
    return { status: FAILED, detail };
  }

  const data = await response.json();
  return { status: SUCCESS, data };
};
